<template>
    <v-container mt-n7 :class="$style.accountUnvalidateFeedWrapper">
        <v-card flat style="margin: 0 6% auto" :class="$style.accountUnvalidateFeedCard">
            <v-card-title class="justify-center mb-3">
                <SvgIcon :src="getSource"/>            
            </v-card-title>        
            <v-card-text class="justify-center red--text text--lighten-2"><str index="message > account not validated" /></v-card-text>
            
            <v-card-actions class="justify-center">       
                <v-btn @click="resend" :color="button_color" :dark="dark" nw-data="button_signIn" :class="$style.actionBtn">
                    <template v-if="$store.getters.busy==0">
                        <span style="text-transform: initial">
                            <str index="button > resend" />
                        </span>
                    </template>

                    <v-progress-circular v-else indeterminate size="20"></v-progress-circular>
                </v-btn>
            </v-card-actions>            
        </v-card> 
    </v-container>
</template>

<script>
import SvgIcon from '@/components/svg/svg_icon.vue';
import ErrorIcon from '@/assets/images/icons/error.svg';

export default {
    name: 'AccountUnvalidatedFeed',
    components: {
        SvgIcon
    },            
    props: {
        color: {
            type: String,
            default: 'lightgrey'
        },
        button_message: {
            type: String,
            default: null
        },
        dark: {
            type: Boolean,
            default: false
        }
    },
    data: function(){
        return {
            buttonLock: false,
            timer: null,
            waitMessage: null
        }
    },
    methods: {
        resend: function(){
            var self = this;
            if(self.buttonLock===false){
                self.$emit('resend');
            }else{
                self.waitMessage = 'Please wait';
            }
        },
        lock: function(){
            var self = this;

            self.buttonLock=true;
            clearTimeout(self.timer);
            self.timer = setTimeout(function(){
                self.buttonLock = false;
                self.waitMessage = null;
            },1000);
        }
    },
    computed:{
        button_color: function(){
            return this.waitMessage ? 'orange' : this.color;
        },
        message: function(){
            return this.waitMessage ? this.waitMessage : this.button_message;
        },
        busy: function(){
            return this.$store.getters.busy>0;
        },
        getSource: function(){
            return ErrorIcon;
        },        
    },
    watch: {
        busy: function(){
            if(this.busy===true){
                this.lock();
            }
        }
    }
}
</script>

<style module>

.accountUnvalidateFeedWrapper {
    background-image: url("./assets/validate_feed_bkg.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center bottom;
}

.accountUnvalidateFeedCard {
    background: transparent !important;
}
</style>